// Modal.js
import React from "react";
import "../../resources/css/Modal.css";

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div className="terms_layer">
      <div className="cont">
        <div className="close" onClick={onClose}>
          <img src="../custom-resources/img/icon_close.png" alt="Close" />
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
